import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string | string, MessageDescriptor> = defineMessages({
	project: {
		id: 'search-graph-jira-dc.project-result.label',
		defaultMessage: 'Project',
		description:
			'Badge label shown on a Jira Data Center search result card to identify the result type as a project.',
	},
	space: {
		id: 'search-graph-jira-dc.space-result.label',
		defaultMessage: 'Space',
		description:
			'Badge label shown on a Confluence Data Center search result card to identify the result type as a Confluence space.',
	},
	issue: {
		id: 'search-graph-jira-dc.issue-result.label',
		defaultMessage: 'Work item',
		description:
			'Badge label shown on a Jira Data Center search result card to identify the result type as a work item (issue).',
	},
	commment: {
		id: 'search-graph-jira-dc.comment-result.label',
		defaultMessage: 'Comment',
		description:
			'Badge label shown on a Jira Data Center search result card to identify the result type as a comment.',
	},
});
